import React from "react"

import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"
import {FieldViewSize} from "../../../../../const"
import {EntityType} from "../../../../../../gd/const/item"

// const debug = "FieldCurrency_TableCell"
const debug = false

export default function FieldCurrency_TableCell(props: FieldTableCellProps) {

    let isEditable: boolean
    switch (props.listItem.type) {
        case EntityType.TASK:
        case EntityType.PROJECT:
            isEditable = !props.manager.isReadOnly && props.listItem.availableCustomFieldsIds.includes(props.field.fieldId) && !props.field.isDisabled
            break

        case EntityType.EVENT:
        case EntityType.GROUP:
        default:
            isEditable = false
    }

    const onChange = (value:any) => {

        // if field has tableCellOnValueChange - use it !!!
        if (props.field.fieldParams.tableCellOnValueChange) {
            props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)
            return
        }

        // Otherwise default = custom field



        // this is for custom fields (!!!)
        // system fields should have their own

        props.listItem.task.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.task.save()

        // need decide how to approach this ...
        // i guess some custom fields can do it (based ion type)
        // some not - it' about aggregation
        props.listItem.updateLastUpdateTime() // otherwise it wont re-render

        FieldProto_updateView(props.manager, props.field)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render", props.listItem.debugName, isEditable)

    return (
        <div className="cell-flex p-h-0" style={style}>
            <props.field.renderComponents.editable
                size        = {FieldViewSize.SMALL}
                className   = "w-100-percent h-100-percent"
                disabled    = {!isEditable}
                field       = {props.field}
                model       = {props.listItem.item}
                onChange    = {props.onChange ? props.onChange : onChange}
                onBlur      = {props.onBlur}
                onFocus     = {props.onFocus}
            />
        </div>
    )
}
